import {Cureus} from '../Cureus';

Cureus.PaymentConfirmation= {};

//= require_tree ./PaymentConfirmation
